const DISMISSIBLE_BANNER_PREFIX = 'fw:dismissible-banner'

export const buildDismissibleBannerKey = (name, scope = 'global') =>
  `${DISMISSIBLE_BANNER_PREFIX}:${name}:${scope || 'global'}`

export const isDismissibleBannerHidden = key => {
  if (!key || typeof window === 'undefined') return false

  try {
    return window.localStorage.getItem(key) === 'hidden'
  } catch (err) {
    return false
  }
}

export const hideDismissibleBanner = key => {
  if (!key || typeof window === 'undefined') return

  try {
    window.localStorage.setItem(key, 'hidden')
  } catch (err) {
    // Local storage can be unavailable in private browsing or blocked contexts.
  }
}
